import { useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import Content from "./content";
import UserContext from "../context/user";
import Translate from "./translate";
import Title from "./title";
import useTealiumOnPageLoad from "../utils/tealium";
import LanguageContext from "../context/language";

const CmsPage = ({ path, title = "", setNavigation, appLang }) => {
  const { logged, callApi } = useContext(UserContext);
  const { cmsLanguages } = useContext(LanguageContext);
  const lang = useMemo(
    () => cmsLanguages.find((lang) => lang.profile === appLang.value).value,
    [cmsLanguages, appLang]
  );
  useTealiumOnPageLoad({ pageSection1: path });

  const { isLoading: pathLoading, data: resourceId } = useQuery(
    ["resource-path", lang, path],
    () => callApi(`/resource/coldpage?path=intranet-${lang}/${path}`),
    {
      enabled: logged && !!lang,
      select: (data) => data?.grid?.rows?.[0]?.placements?.[0]?.items?.[0]?.id,
    }
  );

  const { isLoading: resourceLoading, data: pageContent } = useQuery(
    ["resource-id", resourceId],
    () => callApi(`/resource/custom/${resourceId}`),
    {
      enabled: !!resourceId,
    }
  );

  return pathLoading || resourceLoading ? (
    <div className="loading-spinner" />
  ) : (
    <div>
      <Title handleNavigation={() => setNavigation(null)}>
        <Translate text={title || pageContent?.title} />
      </Title>
      <Content news={pageContent} className="app__content wrapper wrapper-small text" />
    </div>
  );
};

export default CmsPage;
